const SPACE = "\u0020";

/**
 * @param {String[]} xs
 * @return {String}
 */
export const joinWithSpace = xs => xs.join(SPACE);
